import { useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import NormalInput2 from "../../components/inputs/NormalInput2";
import SimpleDropdownInput from "../../components/inputs/SimpleDropdownInput";
import { dummyPlaces } from "../../dummyData";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import AvailabililityInput from "../../components/inputs/AvailabililityInput";
import DiscountModal from "../../components/modals/DiscountModal";
import ImagesUploadInput from "../../components/inputs/ImagesUploadInput";
import InfoModal from "../../components/modals/InfoModal";
import InfoModal2 from "../../components/modals/InfoModal2";
import ThankYouModal2 from "../../components/modals/ThankYouModal2";
import PeopleInRadiusSelect from "../../components/inputs/PeopleInRadiusSelect";
import { useGoBack } from "../../utils";
import { useTranslation } from "../../languages";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
const AddSpecialEvent = () => {
  const { t } = useTranslation();
  const [eventData, setEventData] = useState({
    place: "",
    categories: [],
    title: "",
    availibility: [
      { from: new Date().getTime(), to: new Date().getTime(), title: "Monday" },
    ],
    reservationLink: "",
    offers: [],
    description: "",
    photos: [],
  });
  const goBack = useGoBack();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [peopleSelectorOpen, setPeopleSelectorOpen] = useState(false);
  const {placesListData}=usePlaceHooks()

  return (
    <div>
      <Container fluid>
        <Header title={t("myEvents")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-7 color-primary-blue m-0 figma-font-h5">
            {t("addYourSpecialEvent")}
          </h5>
          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            {t("close")}
          </Button>
        </div>
        <Card className="border-none  figma-card-radius p-0">
          <CardBody className="padding-top-42px padding-left-42px padding-right-42px">
            <div
              className="position-absolute d-none d-md-block "
              style={{ right: `2.63rem`, top: 16 }}
            >
              <InfoModal2
                text={t("specialEventText")}
                title={t("specialEvent")}
              />
            </div>
            <Row
              style={{ "--bs-gutter-y": "1.25rem" }}
              className="justify-content-center"
            >
              <Col md={6}>
                <NormalInput2
                  label={t("place")}
                  type={"select"}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, place: v }))
                  }
                  options={placesListData?.map((i)=>i?.name)}
                  value={eventData?.place}
                />
              </Col>
              <Col md={6}>
                <MultiSelectInput
                  label={t("type")}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, categories: v }))
                  }
                  options={["Choice1", "Choice2", "Choice3"]}
                  value={eventData?.categories ?? []}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  label={t("title")}
                  placeholder={t("writeTitle")}
                  value={eventData?.title}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, title: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <AvailabililityInput
                  label={t("availability")}
                  value={eventData?.availibility}
                  setAvailabilityValue={(v)=>setEventData((prev)=>({...prev,availibility:v}))}
                  t={t}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"link"}
                  placeholder={t("writeReservationLinkHere")}
                  value={eventData?.reservationLink}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, reservationLink: v }))
                  }
                  label={t("reservationLink")}
                />
              </Col>
              <Col md={6}>
                <DiscountModal label={t("offeredDiscounts")} value={eventData?.offers??[]}
                
                setValue={(v)=>setEventData((prev)=>({...prev,offers:v}))}/>
              </Col>
              <Col md={12}>
                <NormalInput2
                  label={t("enterDescription")}
                  placeholder={t("writeDescription")}
                  type={"textarea"}
                  value={eventData?.description}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, description: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <ImagesUploadInput
                  label={t("addPhotos")}
                  value={eventData?.photos}
                  maxImages={3}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, photos: v }))
                  }
                />
              </Col>
              <Col md={5} className="mt-5 mb-2">
                <Button
                  onClick={() => {
                    setPeopleSelectorOpen(true);
                  }}
                  className="standard-rounded-btn full-width"
                >
                  {t("payNow")} $5.00
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      {/* people selector */}
      <PeopleInRadiusSelect
        onSuccess={() => setSuccessModalOpen(true)}
        isOpen={peopleSelectorOpen}
        setisOpen={setPeopleSelectorOpen}
      />
      {/* modal */}
      <ThankYouModal2
        isOpen={successModalOpen}
        setisOpen={setSuccessModalOpen}
        text={`The amount has been Transferred successfully!. Your event is
                currently pending approval. We will notify you once our admin team
                approves it.`}
      />
    </div>
  );
};
export default AddSpecialEvent;
